import React from 'react'

const Spinner = ({ size = 40, color, style, className = '', ...other }) => {
  const inherit = color === 'inherit'
  return (
    <span
      className={`edvi-spinner ${className}`.trim()}
      style={{
        width: size,
        height: size,
        marginLeft: '50%',
        position: 'relative',
        left: `-${size / 2}px`,
        top: '1rem',
        ...(inherit
          ? {
              borderColor:
                'currentColor transparent currentColor transparent',
            }
          : null),
        ...style,
      }}
      role="status"
      aria-label="Loading"
      {...other}
    />
  )
}

export default Spinner
